import React from "react";
import Navbar from "../../components/Navbar";
import { Card, Col, Row } from "antd";
import WidgetBar from "../../components/WidgetBar";

import { Pie } from "@ant-design/plots";

const data = [
  {
    type: "Congelados",
    value: 27,
  },
  {
    type: "Salarios",
    value: 25,
  },
  {
    type: "Socios",
    value: 18,
  },
  {
    type: "Impuestos",
    value: 15,
  },
  {
    type: "Insumos",
    value: 15,
  },
  {
    type: "Arreglos",
    value: 10,
  },
  {
    type: "Limpieza",
    value: 5,
  },
];

const configPie = {
  appendPadding: 20,
  data,
  angleField: "value",
  colorField: "type",
  radius: 0.6,
  legend: false,
  label: {
    type: "spider",
    labelHeight: 28,
    content: "{name}\n{percentage}",
  },
  interactions: [
    {
      type: "element-selected",
    },
    {
      type: "element-active",
    },
  ],
};

const axiosConfig = {
  withCredentials: true,
  credentials: "include",
  headers: {
    "Content-Type": "application/json",
  },
};

const NegociosGastos = () => {
  return (
    <div>
      <Navbar />
      <WidgetBar></WidgetBar>

      <Row gutter={16}>
        <Col span={20}>
          <Card title="Gastos del Mes" bordered={true}>
            <Pie {...configPie} autoFit={true} />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default NegociosGastos;
